import { Packs } from "modules/packs";

const PacksPage = () => <Packs />;

export default PacksPage;
